import { c as _c } from "react/compiler-runtime";
import { IconExternalLink } from "@tabler/icons-react";
import { KeyValue } from "@/components/domain/key-value";
import { KeyValueGrid } from "@/components/domain/key-value-grid";
import { PillCount } from "@/components/domain/pill-count";
export function MetaTagsGrid(t0) {
  const $ = _c(12);
  const {
    metaTagValues
  } = t0;
  let t1;
  if ($[0] !== metaTagValues) {
    t1 = metaTagValues.filter(_temp);
    $[0] = metaTagValues;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const count = t1.length;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Meta Tags</span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== count) {
    t3 = <div className="flex items-center gap-2 text-[11px] leading-none tracking-[0.08em] text-foreground/70 uppercase dark:text-foreground/80">{t2}<PillCount count={count} color="orange" /></div>;
    $[3] = count;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== metaTagValues) {
    t4 = metaTagValues.filter(_temp2).map(_temp3);
    $[5] = metaTagValues;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <KeyValueGrid colsDesktop={2}>{t4}</KeyValueGrid>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <div className="space-y-3">{t3}{t5}</div>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
function _temp3(t_1) {
  return <KeyValue key={t_1.label} label={t_1.label} value={String(t_1.value)} suffix={String(t_1.value).startsWith("http://") || String(t_1.value).startsWith("https://") ? <a href={String(t_1.value)} target="_blank" rel="noopener" className="text-muted-foreground hover:text-foreground" title="Open URL in new tab"><IconExternalLink className="!size-3.5" aria-hidden={true} /></a> : null} copyable={true} />;
}
function _temp2(t_0) {
  return t_0.value != null;
}
function _temp(t) {
  return t.value != null;
}